export const CHATBOT_ID = 'chatbot';
